import { useAuth } from "@/context/AuthContext";
import { useFilters } from "@/hooks/useFilters";
import PageHeader from "@/components/common/PageHeader";
import FilterBar from "@/components/common/FilterBar";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ReportsTable from "@/components/reports/ReportsTable";
import AnalyticsPanel from "@/components/reports/AnalyticsPanel";
import { Table2, PieChart } from "lucide-react";

export default function Reports() {
  const { user } = useAuth();
  const { filters, setFilters, apiParams, params } = useFilters();
  const tab = params.get("tab") || "reports";
  const reportKey = params.get("report") || "";
  const canExport = ["super_admin", "manager", "finance_manager"].includes(user?.role);

  return (
    <div className="space-y-6">
      <PageHeader title="Reports & Analytics" subtitle="Filterable, exportable reports and visual analytics — scoped to your access." testid="reports-header" />
      <FilterBar filters={filters} setFilters={setFilters} testid="reports-filter-bar" />
      <Tabs value={tab} onValueChange={(v) => setFilters({ tab: v })}>
        <TabsList data-testid="reports-tabs">
          <TabsTrigger value="reports" className="gap-1.5" data-testid="tab-reports"><Table2 className="h-4 w-4" /> Reports</TabsTrigger>
          <TabsTrigger value="analytics" className="gap-1.5" data-testid="tab-analytics"><PieChart className="h-4 w-4" /> Analytics</TabsTrigger>
        </TabsList>
        <TabsContent value="reports" className="mt-4">
          <ReportsTable apiParams={apiParams} reportKey={reportKey} canExport={canExport} onReportChange={(k) => setFilters({ report: k })} />
        </TabsContent>
        <TabsContent value="analytics" className="mt-4">
          {tab === "analytics" && <AnalyticsPanel apiParams={apiParams} />}
        </TabsContent>
      </Tabs>
    </div>
  );
}
